// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2890":"d78272ae","2947":"11b01132","2970":"708353fd","4639":"708353fd","5483":"708353fd"}[chunkId] + ".chunk.css";
};